import { render, staticRenderFns } from "./OIDRegister.vue?vue&type=template&id=6cb56d94&scoped=true"
import script from "./OIDRegister.vue?vue&type=script&lang=js"
export * from "./OIDRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb56d94",
  null
  
)

export default component.exports